module.exports = __webpack_public_path__ + "static/home1-header-left-19eb5aa36483e6465c6c7a7858ae8ad8.png";